import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";

interface CancelPrescriptionResponse {
  bundle: object;
}

export const useCancelPrescription = ({
  patientId,
  encounterId,
  medicationRequestId,
}: {
  patientId: string;
  encounterId: string;
  medicationRequestId: string;
}) => {
  const queryClient = useQueryClient();

  return useApiMutation<CancelPrescriptionResponse, void>({
    mutationOptions: {
      mutationKey: QueryKeys.Patient.Chart.Prescriptions.CANCEL(
        patientId,
        encounterId,
        medicationRequestId,
      ),
      mutationFn: (params) => {
        return axiosInstance.patch(
          `/rx/prescriptions/${medicationRequestId}/cancel`,
          params,
        );
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.Chart.Prescriptions.DEFAULT(
            patientId,
            encounterId,
          ),
        });
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.SUMMARY({
            patientId,
            encounterId,
          }),
        });
      },
    },
  });
};
